import { ACTIONS } from "./../constants"


const initialState = {
  activityReports: [],
  activityReport: {},
  totalSize: 0,
  isFetching: false,
  isLoading: false,
  hasMore: true,
  success: {
    isDeactivated: false,
    isCreated: false,
    isUpdated: false,
    isActivated: false,
    isDeleted: false,
  },
  error: null
}


export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_ACTIVITY_REPORT: {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_ACTIVITY_REPORTS_INIT: {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_ACTIVITY_REPORTS_SUCCEDED: {
      const { count, results } = payload
      return { ...state, totalSize: count, activityReports: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_ACTIVITY_REPORTS_FAILED: {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_ACTIVITY_REPORT_SUCCEDED: {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_ACTIVITY_REPORT_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.EDIT_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_ACTIVITY_REPORT_SUCCEDED: {
      return { ...state, activityReport: payload, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_ACTIVITY_REPORT_FAILED: {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.FETCH_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, activityReport: null, error: null }
    }
    case ACTIONS.FETCH_ACTIVITY_REPORT_SUCCEDED: {
      const {reportDetails}=payload
      return { ...state, activityReport: { ...payload,reportDetails:reportDetails.map((val)=>val.report),reports:reportDetails /* ,reportFileSet:payload?.reportDetails */ }, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_ACTIVITY_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ACTIVATE_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ACTIVATE_ACTIVITY_REPORT_SUCCEDED: {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ACTIVATE_ACTIVITY_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DEACTIVATE_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DEACTIVATE_ACTIVITY_REPORT_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DEACTIVATE_ACTIVITY_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DELETE_ACTIVITY_REPORT_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_ACTIVITY_REPORT_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_ACTIVITY_REPORT_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
